import React from "react";
import "@assets/css/SplashLoader.css";
const SplashLoader = () => {
  return (
    <div className="h-screen flex items-center justify-center">
      <div class="mask">
        <div class="loader">
          <div class="loader__bounce first"></div>
          <div class="loader__bounce second"></div>
          <div class="loader__bounce third"></div>
        </div>
      </div>
    </div>
  );
};

export default SplashLoader;
